import { store } from '@betacrew/jars-flux'
export const componentKey = "ASSIGN_PAYERS";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setPayersData : (state, action) => {
            state.payersData = action.payload;
        },
        setSkip : (state, action) => {
            state.skip = action.payload;
        },
        setRowsPerPage : (state, action) => {
            state.rowsPerPage = action.payload;
        },
        setFilterText : (state, action) => {
            state.filterText = action.payload;
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setTotalPayers: (state, action) => {
            state.totalPayers = action.payload;
        },
        setGroupIDs: (state, action) => {
            state.groupIDs = action.payload;
        },
        setGroupIdChecked: (state, action) => {
            state.groupIdChecked = action.payload;
        },
    }, 
    initialReducerState: {
        payersData: [],
        groupIDs: [],
        totalPayers: 0,
        rowsPerPage: 10,
        skip: 0,
        filterText: "",
        groupIdChecked: false,
        loadingState: false,
    }
});
export const { setGroupIdChecked, setLoadingState, setPayersData, setRowsPerPage, setSkip, setFilterText, setTotalPayers, setGroupIDs } = actions;